// TODO Use babel plugin: "@babel/plugin-proposal-export-default-from"

import _TableItem from './TableItem';
export const TableItem = _TableItem;
